import {
  Button as NextUIButton,
  ButtonProps as NextUIButtonProps,
} from "@heroui/react";

export interface ButtonProps extends NextUIButtonProps {
  to?: string;
}

export const Button = ({ ...props }: ButtonProps) => {
  return <NextUIButton {...props}>{props.children}</NextUIButton>;
};

export default Button;
